import config from "./config";
var axios = config();

export default {
  getOpportunity(id) {
    return axios.get("/api/Opportunities/GetOpportunityById", {
      params: { id: id }
    });
  },

  getOpportunities(term) {
    var query = "";
    if (term) {
      query = "?term=" + term;
    }
    return axios.get("/api/Opportunities/GetActiveOpportunities" + query, {
      params: {}
    });
  },

  getOpportunitiesByUser() {
    return axios.get("/api/Opportunities/GetOpportunitiesByUser", {
      params: {}
    });
  },

  getPublishedOpportunitiesByTerm(termId) {
    return axios.get("/api/Opportunities/GetPublishedOpportunities", {
      params: { TermId: termId }
    });
  },

  getNotPublishedOpportunitiesByTerm(termId) {
    return axios.get("/api/Opportunities/GetNotPublishedOpportunities", {
      params: { TermId: termId }
    });
  },

  getNotReadyOpportunitiesByTerm(termId) {
    return axios.get("/api/Opportunities/GetNotReadyOpportunities", {
      params: { TermId: termId }
    });
  },

  getOpportunityCategories() {
    return axios.get("/api/OpportunityCategories/GetOpportunityCategories", {});
  },

  getInternshipCourses() {
    return axios.get("/api/Opportunities/GetInternshipCourses", {});
  },

  getOpportunityTypes() {
    return axios.get("/api/Opportunities/GetOpportunityTypes", {});
  },

  getOpportunityFiles(opportunityId) {
    return axios.get("/api/Opportunities/GetActiveOpportunityFiles", {
      params: { id: opportunityId }
    });
  },

  postOpportunity(opportunity) {
    return axios.post("/api/Opportunities/AddOpportunity", opportunity);
  },

  postEditOpportunity(opportunity) {
    return axios.post("/api/Opportunities/EditOpportunity", opportunity);
  },

  postPublishOpportunities(opportunities) {
    return axios.post("/api/Opportunities/PublishOpportunities", opportunities);
  },

  postCopyOpportunities(termId, opportunityIds) {
    return axios.post(
      "/api/Opportunities/CopyOpportunities?termId=" + termId,
      opportunityIds
    );
  },

  postOpportunityFile(formData, files) {
    return axios({
      method: "POST",
      url: "/api/Opportunities/AddOpportunityFile",
      transformRequest: function(data) {
        var formData = new FormData();
        // need to convert our json object to a string version of json otherwise
        // the browser will do a 'toString()' on the object which will result
        // in the value '[Object object]' on the server.
        formData.append("data", JSON.stringify(data.data));
        //now add all of the assigned files
        for (var i = 0; i < data.files.length; i++) {
          //add each file to the form data and iteratively name them
          formData.append("file" + i, data.files[i]);
        }
        return formData;
      },
      data: { data: formData, files: files } // pass in data as strings
      //headers: { "Content-Type": undefined } // set the headers so angular passing info as form data (not request payload)
    });
  },

  putPublishState(id, state) {
    return axios.put("/api/opportunities/" + id + "/published?state=" + state)
  },

  deleteOpportunity(opportunityId) {
    return axios.delete(
      "/api/Opportunities/DeleteOpportunity/" + opportunityId
    );
  }
};
